import React, {Component} from "react";
import './frontpage.scss';
import Button from 'react-bootstrap/Button';
import AssistBar from "../components/assistbar";
// import TopNavbar from "./components/navbar";

class FrontPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {

        }
      }

    componentDidMount(){
        document.getElementById("frontpage-vid").play();
    }

  render(){

    return (
      <div className="main">

          <AssistBar {...this.props} setval={this.props.setval} />

          <div className="vid-wrapper">
              <video autoPlay muted playsInline loop id="frontpage-vid" >
                <source src="/assets/frontpage-vid.mp4" type="video/mp4" />
                "Your browser doesn't support the video tag."
              </video>
          </div>

          <div className={"frontpage-promotag"} >
            <div>{"All items 10% OFF"}</div>
            <div>{"Worldwide Free Shipping"}</div>
          </div>


          <div className={"frontpage-title"}>
              <i><u>{"Our Signature Items"}</u></i>
          </div>

          <div className="frontpage-board">
              <div className="frontpage-board-left" onClick={(e)=>{
                this.props.setval({
                  currentPage:"detailpage",
                  previousView: "frontpage",
                  chosenProduct:{
                    "cat":this.props.frontpageProduct["1"]["cat"],
                    "item":this.props.frontpageProduct["1"]["item"],
                  }})
              }}>
                <img className={"display-profile"} src={"/assets/"+this.props.frontpageProduct["1"]["cat"]+"-"+this.props.frontpageProduct["1"]["item"]+"-1.PNG"}  />
                <div className="des-box">{(this.props.productList[this.props.frontpageProduct["1"]["cat"]][this.props.frontpageProduct["1"]["item"]]["description"].length < 100)?
                this.props.productList[this.props.frontpageProduct["1"]["cat"]][this.props.frontpageProduct["1"]["item"]]["description"]:
                  this.props.productList[this.props.frontpageProduct["1"]["cat"]][this.props.frontpageProduct["1"]["item"]]["description"].slice(0,90)+"..."}</div>
              </div>

              <div className="frontpage-board-right">
                    <div className="frontpage-board-right-up">
                    
                        <div className="frontpage-board-right-up-box" onClick={(e)=>{
                this.props.setval({
                  currentPage:"detailpage",
                  previousView: "frontpage",
                  chosenProduct:{
                    "cat":this.props.frontpageProduct["2"]["cat"],
                    "item":this.props.frontpageProduct["2"]["item"],
                  }})
              }}>
                        <img className={"display-profile"} src={"/assets/"+this.props.frontpageProduct["2"]["cat"]+"-"+this.props.frontpageProduct["2"]["item"]+"-1.PNG"}  />
                        <div className="des-box">{(this.props.productList[this.props.frontpageProduct["2"]["cat"]][this.props.frontpageProduct["2"]["item"]]["description"].length < 100)?
                this.props.productList[this.props.frontpageProduct["2"]["cat"]][this.props.frontpageProduct["2"]["item"]]["description"]:
                  this.props.productList[this.props.frontpageProduct["2"]["cat"]][this.props.frontpageProduct["2"]["item"]]["description"].slice(0,90)+"..."}</div>
                        </div>
                        <div className="frontpage-board-right-up-box" onClick={(e)=>{
                this.props.setval({
                  currentPage:"detailpage",
                  previousView: "frontpage",
                  chosenProduct:{
                    "cat":this.props.frontpageProduct["3"]["cat"],
                    "item":this.props.frontpageProduct["3"]["item"],
                  }})
              }}>
                        <img className={"display-profile"} src={"/assets/"+this.props.frontpageProduct["3"]["cat"]+"-"+this.props.frontpageProduct["3"]["item"]+"-1.PNG"}  />
                        <div className="des-box">{(this.props.productList[this.props.frontpageProduct["3"]["cat"]][this.props.frontpageProduct["3"]["item"]]["description"].length < 100)?
                this.props.productList[this.props.frontpageProduct["3"]["cat"]][this.props.frontpageProduct["3"]["item"]]["description"]:
                  this.props.productList[this.props.frontpageProduct["3"]["cat"]][this.props.frontpageProduct["3"]["item"]]["description"].slice(0,90)+"..."}</div>
                        </div>

                    </div>
                    <div className="frontpage-board-right-down" onClick={(e)=>{
                this.props.setval({
                  currentPage:"detailpage",
                  previousView: "frontpage",
                  chosenProduct:{
                    "cat":this.props.frontpageProduct["4"]["cat"],
                    "item":this.props.frontpageProduct["4"]["item"],
                  }})
              }}>
                    <img className={"display-profile"} src={"/assets/"+this.props.frontpageProduct["4"]["cat"]+"-"+this.props.frontpageProduct["4"]["item"]+"-1.PNG"}  />
                    <div className="des-box">{(this.props.productList[this.props.frontpageProduct["4"]["cat"]][this.props.frontpageProduct["4"]["item"]]["description"].length < 100)?
                this.props.productList[this.props.frontpageProduct["4"]["cat"]][this.props.frontpageProduct["4"]["item"]]["description"]:
                  this.props.productList[this.props.frontpageProduct["4"]["cat"]][this.props.frontpageProduct["4"]["item"]]["description"].slice(0,90)+"..."}</div>
                    </div>
                </div>
          </div>


      </div>
    );


  }
}

export default FrontPage;
